import { useState } from 'react';
import { Button } from '../../components/ui/button';
import PageHeader from '../../components/common/PageHeader';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '../../components/ui/card';
import { Save } from 'lucide-react';
import IBLevelSettings, {
  IBLevelSettingsData,
} from '../../components/ib/IBLevelSettings';
import PayoutFrequency, {
  PayoutFrequencyData,
} from '../../components/ib/PayoutFrequency';
import CurrencySettings, {
  CurrencySettingsData,
} from '../../components/ib/CurrencySettings';
import { CommissionRulesData } from '../../constants/commissionRuleOptions';
import CommissionRules from '../../components/ib/CommissionRules';

const IBSettings = () => {
  const [commissionRules, setCommissionRules] = useState<CommissionRulesData>({
    commissionType: 'lot-based',
    commissionRate: 15,
    minimumPayoutAmount: 100,
    negativeBalanceProtection: false,
  });

  const [ibLevelSettings, setIBLevelSettings] = useState<IBLevelSettingsData>({
    currentIBLevel: 'master-ib',
    maximumSubIBLevels: 3,
    subIBCommissionShare: 10,
    autoApproveSubIB: true,
  });

  const [payoutFrequency, setPayoutFrequency] = useState<PayoutFrequencyData>({
    payoutSchedule: 'monthly',
    payoutDay: 'last-day',
    paymentMethod: 'bank-transfer',
    autoWithdrawal: false,
  });

  const [currencySettings, setCurrencySettings] =
    useState<CurrencySettingsData>({
      baseCurrency: 'usd',
      displayCurrency: 'usd',
      timezone: 'local',
      dateFormat: 'mm/dd/yyyy',
    });

  return (
    <div className="space-y-6">
      <div className="sticky top-0 z-20 bg-background pt-4">
        <PageHeader
          title="IB Settings"
          description="Configure your IB account preferences and commission rules"
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <CommissionRules data={commissionRules} onChange={setCommissionRules} />
        <IBLevelSettings data={ibLevelSettings} onChange={setIBLevelSettings} />
        <PayoutFrequency data={payoutFrequency} onChange={setPayoutFrequency} />
        <CurrencySettings
          data={currencySettings}
          onChange={setCurrencySettings}
        />
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Save Changes</CardTitle>
          <CardDescription>Apply your settings changes</CardDescription>
        </CardHeader>
        <CardContent>
          <div className="flex flex-col sm:flex-row gap-4">
            <Button className="flex-1">
              <Save className="h-4 w-4 mr-2" />
              Save Settings
            </Button>
            <Button variant="outline" className="flex-1">
              Reset to Default
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default IBSettings;
